import { LoadingSpinner, Text, Title } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";

export function PandaDocEmbeddedSessionLoader() {
  return (
    <Stack
      spacing={8}
      sx={{
        width: "100%",
        height: "100%",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
      }}
    >
      <LoadingSpinner size="large" variant="secondary" />
      <Stack spacing={7} justifyContent="center" alignItems="center" sx={{ textAlign: "center" }}>
        <Title component="h3" sx={{ textWrap: "balance" }}>
          Loading Document
        </Title>
        <Text
          variant="body1"
          sx={(theme) => ({ color: theme.palette.text.secondary, paddingX: 4 })}
        >
          This usually takes a few seconds. Please don't close the app.
        </Text>
      </Stack>
    </Stack>
  );
}
